import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { asArray } from '@olivierpascal/helpers';
import { useStyles } from '../../hooks/useStyles';
import { iconXMark } from '../../assets/icons';
import { Elevation } from '../Elevation';
import { Button } from '../Button';
import { IconButton } from '../IconButton';
import { SvgIcon } from '../SvgIcon';
import { snackbarContentElevationStyles, snackbarContentStyles, } from './SnackbarContent.styles';
import { snackbarContentTheme } from './SnackbarContent.stylex';
import { Stack } from '../Stack';
export const SnackbarContent = forwardRef(function SnackbarContent(props, forwardedRef) {
    const { styles, sx, innerStyles, children, actionLabel, onActionClick, onClose, showCloseButton, ...other } = props;
    const { combineStyles, getStyles, globalStyles } = useStyles({
        name: 'SnackbarContent',
        styles: [snackbarContentStyles, styles],
    });
    return (_jsxs(Stack, { ...other, horizontal: true, align: 'center', gap: 3, wrap: true, sx: [
            snackbarContentTheme,
            globalStyles,
            combineStyles('host', actionLabel
                ? 'host$trailingAction'
                : onClose
                    ? 'host$trailingIcon'
                    : undefined),
            sx,
        ], ref: forwardedRef, children: [_jsx(Elevation, { styles: [
                    snackbarContentElevationStyles,
                    ...asArray(innerStyles?.elevation),
                ] }), _jsx("div", { ...getStyles('supportingText'), children: children }), (actionLabel ?? showCloseButton) ? (_jsxs(Stack, { horizontal: true, gap: 2, sx: combineStyles('actions'), children: [actionLabel ? (_jsx(Button, { variant: 'snackbar', onClick: onActionClick, children: actionLabel })) : null, showCloseButton ? (_jsx(IconButton, { variant: 'snackbar', icon: _jsx(SvgIcon, { icon: iconXMark }), onClick: onClose, "aria-label": 'close' })) : null] })) : null] }));
});
